export const EDIT_TYPE = {
    SLIDE: 'slide',
    MASTER_LAYOUT: 'masterLayout',
};
